import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import style from "../assets/css/components/TableGral.module.css";
import classnames from "classnames";

function TableGral({ headerBlack, data }) {
  const [dataTable, setDataTable] = useState([]);

  useEffect(() => {
    if (data) {
      let puntos = [...data];

      puntos.sort(
        (a, b) => a.pts - b.pts || a.dif - b.dif || a.gf - b.gf || b.ge - a.ge
      );

      const dataReverse = puntos.reverse();
      setDataTable(dataReverse);
    }
  }, [data]);

  return (
    <div className={style.contTable}>
      <table className={style.table}>
        <thead className={style.headTable}>
          <tr className={style.contColumn}>
            <ColumnHeader headerBlack={headerBlack} text="" />
            <ColumnHeader headerBlack={headerBlack} text="" />
            <ColumnHeader
              headerBlack={headerBlack}
              textLeft={true}
              text="EQUIPO"
            />
            <ColumnHeader headerBlack={headerBlack} text="JJ" />
            <ColumnHeader headerBlack={headerBlack} text="JG" />
            <ColumnHeader headerBlack={headerBlack} text="JE" />
            <ColumnHeader headerBlack={headerBlack} text="JP" />
            <ColumnHeader headerBlack={headerBlack} text="GF" />
            <ColumnHeader headerBlack={headerBlack} text="GE" />
            <ColumnHeader headerBlack={headerBlack} text="DG" />
            <ColumnHeader headerBlack={headerBlack} text="PX" />
            <ColumnHeader headerBlack={headerBlack} text="PT" />
          </tr>
        </thead>
        <tbody className={style.bodyTable}>
          {dataTable &&
            dataTable.map((team, index) => (
              <ListData key={team.id} data={team} position={index + 1} />
            ))}
        </tbody>
      </table>
    </div>
  );
}

const ListData = ({ data, position }) => (
  <tr>
    <td className={position < 9 ? style.bgPos : null}></td>
    <td>{position}</td>
    <td>
      <Link
        className={style.link}
        to={"/team/" + data.team.name}
        state={{ id: data.team.id, position }}
      >
        <p className={style.textLink}>{data.team.name}</p>
      </Link>
    </td>
    <td>{data.jj}</td>
    <td>{data.jg}</td>
    <td>{data.je}</td>
    <td>{data.jp}</td>
    <td>{data.gf}</td>
    <td>{data.ge}</td>
    <td className={data.dif < 0 ? style.danger : style.good}>{data.dif}</td>
    <td>{data.pex}</td>
    <td>{data.pts}</td>
  </tr>
);

const ColumnHeader = ({ text, headerBlack, textLeft }) => (
  <th
    className={
      headerBlack
        ? textLeft
          ? classnames(style.column, style.black, style.textLeft)
          : classnames(style.column, style.black)
        : textLeft
        ? classnames(style.column, style.textLeft)
        : style.column
    }
  >
    {text}
  </th>
);

export default TableGral;
